import { render, staticRenderFns } from "./SalesWeekly.vue?vue&type=template&id=55be76dc&scoped=true&"
import script from "./SalesWeekly.vue?vue&type=script&lang=ts&"
export * from "./SalesWeekly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be76dc",
  null
  
)

export default component.exports